import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import { AnyAction } from 'redux';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import {
  setAppBackUrlAction,
  setAppBasketUrlAction, setAppDraftsUrlAction,
  setAppEditorModeAction,
  setAppForwardUrlAction,
  setAppIsMobileAction,
  setAppFeaturesAction,
} from 'src/store/app/slice';

const setAppInitialStateFromIntegrationLayerOperation = () => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  const {
    backUrl,
    editorMode,
    forwardUrl,
    basketUrl,
    draftsUrl,
    isMobile,
    features,
  } = useIntegrationLayer();
  dispatch(setAppFeaturesAction(features));
  dispatch(setAppBackUrlAction(backUrl));
  dispatch(setAppEditorModeAction(editorMode));
  dispatch(setAppBasketUrlAction(basketUrl));
  dispatch(setAppForwardUrlAction(forwardUrl));
  dispatch(setAppDraftsUrlAction(draftsUrl));
  dispatch(setAppIsMobileAction(isMobile));
};

export default setAppInitialStateFromIntegrationLayerOperation;
